/**
 *
 * @param {string} type
 * @returns string
 */
export const fileTypeCheck = (type) => {
  if (type == null) return null;

  const typeMap = {
    jpeg: "image/jpeg",
    jpg: "image/jpg",
    png: "image/png",
    gif: "image/gif",
    msword: "application/msword",
    "vnd.openxmlformats-officedocument.wordprocessingml.document":
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "vnd.ms-powerpoint": "application/vnd.ms-powerpoint",
    "vnd.openxmlformats-officedocument.presentationml.presentation":
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    "vnd.ms-excel": "application/vnd.ms-excel",
    "vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "x-zip-compressed": "application/x-zip-compressed",
    zip: "application/zip",
    pdf: "application/pdf",
  };

  return typeMap[type] || null;
};
